import SessionList from './SessionList';

export default SessionList;
